import React, { useEffect, useState } from "react";

import { Formik, Form } from "formik";
import * as Yup from "yup";

import { useSelector } from "react-redux";

import { Stack, TextField, Typography } from "@mui/material";
import {
  consultaEstFinanciero,
  crearClienteEstadoFinanciero,
  obtenerPesosActividadEconomica,
} from "../services/clienteService";

import { NumberFormatCustom } from "app/modules/shared/mask/mascaraInputDinero";

import SpinnerLoadSrx from "app/modules/shared/components/SpinnerLoadSrx";
import AcceptServiceresponse from "app/modules/shared/components/AcceptServiceresponse";
import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";
import SCSAccordion from "app/modules/common/components/Accordions/SCSAccordion";

import { StyleInputs } from "../styles/themes";

import SelectItemsCatalogs, {
  SelectItemsCatalogsSpecial,
} from "app/modules/common/components/Selector";

import "../styles/main.css";
import { Box } from "@mui/system";
import MoreInfoPopover from "app/modules/shared/components/MoreInfoPopover";

const FormClienteEstadoFinanciero = ({
  idCliente,
  setActividadEconomica,
  setInfoClienteGrabada,
}) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const [clienteInfo, setClienteInfo] = useState(null);
  const [controlActividad, setControlActividad] = useState(true);
  const [origenIngresos, setOrigenIngresos] = useState("");
  const [datosEnviadosCorrectamente, setDatosEnviadosCorrectamente] =
    useState(false);

  const [idEstadoFinancieroAux, setIdEstadoFinancieroAux] = useState(0);

  const [pesosDependiente, setPesosDependiente] = useState({
    COMISION: 100,
    OTROS: 100,
    REMESA: 100,
    RENTA: 100,
    SUELDO: 100,
    VENTA: 100,
  });

  const [pesosIndependiente, setPesosIndependiente] = useState({
    COMISION: 100,
    OTROS: 100,
    REMESA: 100,
    RENTA: 100,
    SUELDO: 100,
    VENTA: 100,
  });

  useEffect(() => {
    const getData = async () => {
      let infoEstadoFinanciero;

      try {
        const informacionEstadoFinanciero =
          await consultaEstFinanciero(idCliente);

        if (informacionEstadoFinanciero.state) {
          infoEstadoFinanciero = informacionEstadoFinanciero.data;
          setOrigenIngresos(informacionEstadoFinanciero.data.origenIngresos);

          setIdEstadoFinancieroAux(
            informacionEstadoFinanciero.data.idEstadoFinanciero,
          );
        } else {
          infoEstadoFinanciero = {};
        }
      } catch (error) {
        console.log(error);
      }

      const res = {
        ...infoEstadoFinanciero,
      };

      setClienteInfo(res);
    };
    getData();
  }, []);

  useEffect(() => {
    const getPesosDependiente = async () => {
      try {
        const respuestaPesosDependiente =
          await obtenerPesosActividadEconomica("AECDEP");

        if (respuestaPesosDependiente.state) {
          const objectPesosDependiente = respuestaPesosDependiente.data.reduce(
            (acumuladorPesos, valorPeso) => {
              const objetoDependiente = {
                ...acumuladorPesos,
                [valorPeso.tipoIngreso]: valorPeso.porcentaje,
              };

              return objetoDependiente;
            },
            {},
          );

          setPesosDependiente(objectPesosDependiente);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getPesosDependiente();
  }, []);

  useEffect(() => {
    const getPesosIndependiente = async () => {
      try {
        const respuestaPesosDependiente =
          await obtenerPesosActividadEconomica("AECIND");

        if (respuestaPesosDependiente.state) {
          const objectPesosIndependiente =
            respuestaPesosDependiente.data.reduce(
              (acumuladorPesos, valorPeso) => {
                const objetoIndependiente = {
                  ...acumuladorPesos,
                  [valorPeso.tipoIngreso]: valorPeso.porcentaje,
                };

                return objetoIndependiente;
              },
              {},
            );

          setPesosIndependiente(objectPesosIndependiente);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getPesosIndependiente();
  }, []);

  const condicionRederActividadIndependiente = (actividadEconomica) => {
    //Valida Origen ingresos segun opcion seleccionada

    if (actividadEconomica === "PROIND" || actividadEconomica === "NEGPRO") {
      setControlActividad(true);
      setActividadEconomica(true);
      setOrigenIngresos("AECIND");

      return true;
    }
    setControlActividad(false);
    setActividadEconomica(false);
    setOrigenIngresos("AECDEP");
    return false;
  };

  /*  Agregar llamada para obtener los porcentajes y verificar los valores ingresados  */
  const calcularTotalIngresos = (valores) => {
    let respuestaPorcentajes;
    if (origenIngresos === "AECDEP") {
      respuestaPorcentajes = {
        ...pesosDependiente,
      };
    } else {
      respuestaPorcentajes = {
        ...pesosIndependiente,
      };
    }

    let { ingresoMensual, comision, renta, remesa, ventas, otrosIngresos } =
      valores;

    if (origenIngresos === "AECDEP") {
      ventas = 0;
    } else {
      ingresoMensual = 0;
      comision = 0;
    }

    const totalIngresos =
      Number(ingresoMensual) * (Number(respuestaPorcentajes.SUELDO) / 100) +
      Number(comision) * (Number(respuestaPorcentajes.COMISION) / 100) +
      Number(renta) * (Number(respuestaPorcentajes.RENTA) / 100) +
      Number(remesa) * (Number(respuestaPorcentajes.REMESA) / 100) +
      Number(ventas) * (Number(respuestaPorcentajes.VENTA) / 100) +
      Number(otrosIngresos) * (Number(respuestaPorcentajes.OTROS) / 100);

    return totalIngresos.toFixed(2);
  };

  /* dependiendo del origen de ingresos dependiente/independiente cambian los campos de ingresos */
  const validarOrigenIngresos = (origen) => {
    if (origen === "AECDEP") {
      return true;
    } else {
      return false;
    }
  };

  const configuracionDatosEnvio = async (valoresAux, setSubmitting) => {
    setSubmitting(true);

    const valores = { ...valoresAux };

    if (origenIngresos === "AECIND") {
      valores.ingresoMensual = 0;
      valores.comision = 0;
    } else if (origenIngresos === "AECDEP") {
      valores.ventas = 0;
    }

    const today = new Date().toLocaleString("en-US");

    const informacionEstadoFinanciero = {
      idCliente: idCliente,
      idEstadoFinanciero: idEstadoFinancieroAux,
      actividadEconomica: valores.actividadEconomica,
      origenIngresos: origenIngresos,

      ingresoMensual: Number(valores.ingresoMensual),
      comision: Number(valores.comision),
      renta: Number(valores.renta),
      remesa: Number(valores.remesa),
      ventas: Number(valores.ventas),
      otrosIngresos: Number(valores.otrosIngresos),
      totalIngresos: Number(valores.totalIngresos),
      detalleOtrosIngresos: valores.detalleOtrosIngresos.toUpperCase(),

      profesion: valores.profesion,
      esActivo: true,

      fechaCreacion: today,
      usuarioCreacion: authUser.key,
      estacionCreacion: authUser.estacion,
    };

    try {
      const respuestaClienteInformacion = await crearClienteEstadoFinanciero(
        informacionEstadoFinanciero,
      );

      if (respuestaClienteInformacion.state) {
        setDatosEnviadosCorrectamente(true);

        setIdEstadoFinancieroAux(respuestaClienteInformacion.data);
        if (setInfoClienteGrabada) {
          setInfoClienteGrabada((args) => ({
            ...args,
            financiero: true,
          }));
        }

        setTimeout(() => {
          setSubmitting(false);
          setDatosEnviadosCorrectamente(false);
        }, 1000);
      } else {
        setSubmitting(false);
        alert(`${respuestaClienteInformacion.message}`);
      }
    } catch (error) {
      setSubmitting(false);
      alert(`${error.response.data.message}`);
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  const InfoFinanciera = ({}) => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 1,
          p: 1,
          width: "100%",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          INFORMACIÓN FINANCIERA
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Se refiere a la informacion sobre tus ingresos y egresos, toma en
          cuenta que estos son acorde a tu actividad económica.
        </Typography>
      </Box>
    );
  };

  return (
    <>
      {clienteInfo ? (
        <>
          <Formik
            initialValues={{
              // origenIngresos: clienteInfo.origenIngresos || "",
              actividadEconomica: clienteInfo.actividadEconomica || "",
              profesion: clienteInfo.profesion || "",
              ingresoMensual: clienteInfo.ingresoMensual || 0,
              comision: 0,
              renta: 0,
              remesa: 0,
              ventas: clienteInfo.ventas || 0,
              otrosIngresos: clienteInfo.otrosIngresos || 0,
              totalIngresos: clienteInfo.totalIngresos || 0,
              detalleOtrosIngresos: clienteInfo.detalleOtrosIngresos || "",
            }}
            validationSchema={Yup.object({
              // origenIngresos: Yup.string().required(
              //   "Origen Ingresos requerido"
              // ),
              actividadEconomica: Yup.string().required(
                "Actividad Economica requerido",
              ),
            })}
            onSubmit={(values, { setSubmitting }) => {
              configuracionDatosEnvio(values, setSubmitting);
              // console.log(values);
              // console.log(origenIngresos);
            }}
          >
            {({
              values,
              handleChange,
              touched,
              errors,
              handleBlur,
              isSubmitting,
            }) => (
              <Form>
                <SCSAccordion
                  tituloCabecera="Estado Financiero"
                  tieneInfo={true}
                  componenteInformacion={<InfoFinanciera />}
                >
                  <Stack
                    direction="row"
                    spacing={5}
                    alignItems="center"
                    justifyContent={"flex-start"}
                  >
                    <Box>
                      <SelectItemsCatalogs
                        pais="ECU"
                        especial="false"
                        catalogos="TIPOACTEC"
                        grupo={1}
                        name="actividadEconomica"
                        labelName="Actividad Economica"
                        componentSize={{ pcWidth: 100, phoneWidth: 100 }}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                      />
                      {condicionRederActividadIndependiente(
                        values.actividadEconomica,
                      )}
                    </Box>
                  </Stack>

                  <div>
                    <h3>Ingresos</h3>
                  </div>

                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent={"space-between"}
                  >
                    {validarOrigenIngresos(origenIngresos) ? (
                      <>
                        <TextField
                          id="ingresoMensual"
                          name="ingresoMensual"
                          label="Ingreso Mensual"
                          sx={StyleInputs(25, 45)}
                          value={values.ingresoMensual}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={
                            touched.ingresoMensual &&
                            Boolean(errors.ingresoMensual)
                          }
                          helperText={
                            touched.ingresoMensual && errors.ingresoMensual
                          }
                          onBlur={handleBlur}
                        />
                        <TextField
                          id="otrosIngresos"
                          name="otrosIngresos"
                          label="Otros Ingresos"
                          sx={StyleInputs(25, 45)}
                          value={values.otrosIngresos}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={
                            touched.otrosIngresos &&
                            Boolean(errors.otrosIngresos)
                          }
                          helperText={
                            touched.otrosIngresos && errors.otrosIngresos
                          }
                          onBlur={handleBlur}
                        />
                      </>
                    ) : (
                      <>
                        <TextField
                          id="ventas"
                          name="ventas"
                          label="Ventas"
                          sx={StyleInputs(25, 45)}
                          value={values.ventas}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={touched.ventas && Boolean(errors.ventas)}
                          helperText={touched.ventas && errors.ventas}
                          onBlur={handleBlur}
                        />
                        <TextField
                          id="otrosIngresos"
                          name="otrosIngresos"
                          label="Otros Ingresos"
                          sx={StyleInputs(25, 45)}
                          value={values.otrosIngresos}
                          onChange={handleChange}
                          size="small"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={
                            touched.otrosIngresos &&
                            Boolean(errors.otrosIngresos)
                          }
                          helperText={
                            touched.otrosIngresos && errors.otrosIngresos
                          }
                          onBlur={handleBlur}
                        />
                      </>
                    )}

                    <TextField
                      disabled
                      id="totalIngresos"
                      name="totalIngresos"
                      label="Total Ingresos"
                      sx={StyleInputs(25, 45)}
                      value={calcularTotalIngresos(values)}
                      onChange={handleChange}
                      size="small"
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                      error={
                        touched.totalIngresos && Boolean(errors.totalIngresos)
                      }
                      helperText={touched.totalIngresos && errors.totalIngresos}
                      onBlur={handleBlur}
                    />
                  </Stack>

                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent={"space-around"}
                    mt={5}
                  >
                    <TextField
                      id="detalleOtrosIngresos"
                      name="detalleOtrosIngresos"
                      type="text"
                      label="Detalle Otros Ingresos"
                      sx={StyleInputs(100, 100)}
                      value={values.detalleOtrosIngresos}
                      onChange={handleChange}
                      size="small"
                      inputProps={{
                        style: {
                          textTransform: "uppercase",
                        },
                      }}
                      error={
                        touched.detalleOtrosIngresos &&
                        Boolean(errors.detalleOtrosIngresos)
                      }
                      helperText={
                        touched.detalleOtrosIngresos &&
                        errors.detalleOtrosIngresos
                      }
                      onBlur={handleBlur}
                    />
                  </Stack>

                  <div className="confirmar-estados-servicios">
                    <SCSLoadingButton loading={isSubmitting} titulo="GUARDAR" />

                    {datosEnviadosCorrectamente && <AcceptServiceresponse />}
                  </div>
                </SCSAccordion>
              </Form>
            )}
          </Formik>
        </>
      ) : (
        <SpinnerLoadSrx />
      )}
    </>
  );
};

export default FormClienteEstadoFinanciero;
